export enum ApprovalOption {
  APPLY_CHANGES_WITHOUT_APPROVAL = 'APPLY_CHANGES_WITHOUT_APPROVAL',
  REQUEST_APPROVAL = 'REQUEST_APPROVAL',
}

export enum WorkflowNotificationKind {
  REDIRECT = 'redirect',
  LINK_WORKFLOW = 'link-workflow',
  LINK_PENDING_CHANGES_DRAWER = 'link-pending-changes-drawer',
}

export enum WorkflowKind {
  DEFAULT = 'default',
  APPROVAL_REQUEST = 'approval-request',
  SCHEDULED_CHANGE = 'scheduled-change',
  CUSTOM = 'custom',
}

export const DELETE_SCHEDULED_CHANGE_TITLE = 'Delete scheduled change';
